import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { useEffect } from 'react';
import uniqueId from 'lodash.uniqueid';
import { Container, Row, Col } from 'react-bootstrap'; // Design System

import Wrapper from '../wrapper/Wrapper';
import Carousel from '../carousel/Carousel';
import Heading from '../heading/Heading';
import { ProductCard, Card } from '.';
import * as UTIL from "../../util";
import { PowerReviewConfig } from "react-power-reviews";
var id = uniqueId();

var setModel = function setModel(item) {
  try {
    var _item$fields$cardColo, _item$fields$cardColo2;

    var cardColor = typeof item.fields.cardColor !== 'undefined' ? (_item$fields$cardColo = item.fields.cardColor) === null || _item$fields$cardColo === void 0 ? void 0 : (_item$fields$cardColo2 = _item$fields$cardColo.fields) === null || _item$fields$cardColo2 === void 0 ? void 0 : _item$fields$cardColo2.value : '';
    return _objectSpread(_objectSpread({}, item.fields), {}, {
      image: item.fields.image,
      videoUrl: item.fields.videoUrl,
      link: item.fields.link1 || {
        value: {}
      },
      link2: item.fields.link2 || {
        value: {}
      },
      link3: item.fields.link3 || {
        value: {}
      },
      title: item.fields.title,
      titleTag: item.fields.titleTag,
      subtitle: item.fields.subtitle,
      text: item.fields.text,
      linkType: item.fields.linkType || {},
      color: cardColor,
      year: item.fields.year,
      price: item.fields.price,
      calorie: item.fields.calorie,
      likes: item.fields.likes,
      available: item.fields.available,
      defaultOptions: item.fields.defaultOptions,
      tags: item.fields.tags,
      lighterFare: item.fields.lighterFare,
      servingSize: item.fields.servingSize,
      almostGoneBanner: item.fields.almostGoneBanner,
      exclusiveBanner: item.fields.exclusiveBanner,
      exclusiveText: item.fields.exclusiveText,
      sku: item.fields.sku,
      productId: item.fields.productId,
      isFavorite: item.fields.isFavorite
    });
  } catch (e) {
    var _ref;

    return _ref = {
      image: {
        value: {}
      },
      videoUrl: {
        value: {
          href: ""
        }
      },
      link: {
        value: {}
      },
      link2: {
        value: {}
      },
      title: {
        value: ""
      },
      titleTag: {
        value: ""
      },
      subtitle: {
        value: ""
      },
      text: {
        value: ""
      },
      linkType: {},
      color: "",
      year: {
        value: ""
      },
      price: {
        value: ""
      },
      calorie: {
        value: ""
      },
      likes: {
        value: ""
      },
      available: {
        value: ""
      },
      defaultOptions: [],
      tags: "",
      lighterFare: "",
      servingSize: ""
    }, _defineProperty(_ref, "servingSize", ""), _defineProperty(_ref, "almostGoneBanner", ""), _defineProperty(_ref, "exclusiveBanner", ""), _defineProperty(_ref, "exclusiveText", ""), _defineProperty(_ref, "sku", ""), _defineProperty(_ref, "productId", ""), _defineProperty(_ref, "isFavorite", false), _ref;
  }
};

var CardList = function CardList(props) {
  var _props$cards = props.cards,
      cards = _props$cards === void 0 ? [] : _props$cards,
      _props$totalCardsInRo = props.totalCardsInRow,
      totalCardsInRow = _props$totalCardsInRo === void 0 ? 1 : _props$totalCardsInRo,
      _props$layout = props.layout,
      layout = _props$layout === void 0 ? {} : _props$layout,
      isEditing = props.isEditing,
      _props$isProduct = props.isProduct,
      isProduct = _props$isProduct === void 0 ? false : _props$isProduct,
      _props$isRetail = props.isRetail,
      isRetail = _props$isRetail === void 0 ? false : _props$isRetail,
      _props$isPromoProduct = props.isPromoProduct,
      isPromoProduct = _props$isPromoProduct === void 0 ? false : _props$isPromoProduct,
      addToOrder = props.addToOrder,
      noLocation = props.noLocation,
      saveDefault = props.saveDefault,
      _props$showArrows = props.showArrows,
      showArrows = _props$showArrows === void 0 ? false : _props$showArrows,
      isLoading = props.isLoading;
  var _props$cardDisplayTyp = props.cardDisplayType,
      cardDisplayType = _props$cardDisplayTyp === void 0 ? 'carousel' : _props$cardDisplayTyp;
  useEffect(function () {
    if (isRetail) {
      var reviewConfig = _objectSpread({}, UTIL.powerReviewConfig);

      var snippets = cards.map(function (card) {
        return card.fields.sku;
      });

      if (snippets.includes(undefined)) {
        return;
      }

      reviewConfig.component = {
        categorySnippets: "powerReviews-sku"
      };
      reviewConfig.categorySnippets = {
        // This is the base id of the div that you will use
        id: "powerReviews-sku",
        // powerReviews-sku-583514
        snippets: snippets
      };
      PowerReviewConfig(reviewConfig);
    }
  }, [cards]);
  var totalShow = parseInt(totalCardsInRow);

  if (cards.length < parseInt(totalCardsInRow)) {
    cardDisplayType = "list"; //totalShow = cards.length;
  }

  var columns = Math.ceil(12 / parseInt(totalCardsInRow));
  var carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: totalShow,
    slidesToScroll: totalShow,
    arrows: true,
    responsive: [{
      breakpoint: 780,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerPadding: '8%',
        centerMode: true,
        arrows: false
      }
    }, {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '8%',
        arrows: false
      }
    }]
  };
  var CardType = isProduct ? ProductCard : Card;

  var Body = function Body(props) {
    var _cards$, _cards$$fields, _cards$$fields$year;

    var carouselClass = props.carouselClass,
        containerClass = props.containerClass;
    return /*#__PURE__*/React.createElement(Wrapper, {
      layout: layout
    }, /*#__PURE__*/React.createElement(React.Fragment, null, Boolean(carouselClass !== "d-none") && /*#__PURE__*/React.createElement("div", {
      className: "\n      ".concat(carouselClass, "\n    ")
    }, /*#__PURE__*/React.createElement(Carousel, {
      settings: carouselSettings,
      type: "spaced"
    }, cards && cards.map(function (card, index) {
      var model = setModel(card);
      return /*#__PURE__*/React.createElement(CardType, _extends({
        isEditing: isEditing,
        model: model,
        key: "cards-slide-".concat(id, "-").concat(index)
      }, props, {
        isPromoProduct: true
      }));
    }))), /*#__PURE__*/React.createElement(Container, {
      className: "\n      ".concat(containerClass, "\n      ").concat(isProduct ? 'cb-card--small' : '', "\n      ").concat(isRetail ? 'cb-card--retail' : '', "\n\n    ")
    }, cards && ((_cards$ = cards[0]) === null || _cards$ === void 0 ? void 0 : (_cards$$fields = _cards$.fields) === null || _cards$$fields === void 0 ? void 0 : (_cards$$fields$year = _cards$$fields.year) === null || _cards$$fields$year === void 0 ? void 0 : _cards$$fields$year.value) ? /*#__PURE__*/React.createElement(Timeline, {
      cards: cards,
      isEditing: isEditing
    }) : /*#__PURE__*/React.createElement(BasicList, _extends({
      columns: columns,
      isEditing: isEditing,
      cards: cards,
      addToOrder: addToOrder,
      noLocation: noLocation,
      saveDefault: saveDefault,
      CardType: CardType
    }, props, {
      isPromoProduct: true
    })))));
  };

  return isProduct ? /*#__PURE__*/React.createElement(Body, _extends({
    carouselClass: cardDisplayType !== 'carousel' ? 'd-none' : "",
    containerClass: cardDisplayType !== 'carousel' ? 'd-block' : "d-none"
  }, props)) : /*#__PURE__*/React.createElement(Body, _extends({
    carouselClass: cardDisplayType !== 'carousel' ? 'd-md-none' : "",
    containerClass: cardDisplayType !== 'carousel' ? 'd-none d-md-block' : "d-none"
  }, props));
};

var Timeline = function Timeline(_ref2) {
  var cards = _ref2.cards,
      isEditing = _ref2.isEditing;
  return /*#__PURE__*/React.createElement(Row, {
    className: "pt-100__1212"
  }, cards.map(function (card, index) {
    var model = setModel(card, true);
    var diviseby2 = Boolean(index % 2);
    return /*#__PURE__*/React.createElement(Col, {
      lg: 12,
      sm: "12",
      className: "".concat(isEditing ? "cb-card--scEdit" : ""),
      key: "cards-col-".concat(id, "-").concat(index)
    }, /*#__PURE__*/React.createElement(Row, {
      className: "".concat(index !== 0 ? "cb-card__timelinerow mt-neg150" : "cb-card__timelinerow cb-card__timelinerow--first")
    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Card, {
      isEditing: isEditing,
      model: model,
      isTimeline: true,
      className: diviseby2 ? "left" : "right",
      cards: cards
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-card__timelinerunner ".concat(index === cards.length - 1 ? "cb-card__timelinerunner--last" : "", " ").concat(diviseby2 ? "left" : "right")
    }), /*#__PURE__*/React.createElement(Heading, {
      level: "4",
      field: model.year,
      className: "cb-card__timelineyear ".concat(diviseby2 ? "left" : "right")
    })))));
  }));
};

var BasicList = function BasicList(props) {
  var columns = props.columns,
      isEditing = props.isEditing,
      cards = props.cards,
      CardType = props.CardType,
      addToOrder = props.addToOrder,
      noLocation = props.noLocation,
      saveDefault = props.saveDefault;
  return /*#__PURE__*/React.createElement(Row, null, cards.map(function (card, index) {
    var model = setModel(card);
    return /*#__PURE__*/React.createElement(Col, {
      lg: columns,
      md: "6",
      className: "cb-l-margin-medium--bottom ".concat(isEditing ? "cb-card--scEdit" : ""),
      key: "cards-col-".concat(id, "-").concat(index)
    }, /*#__PURE__*/React.createElement(CardType, _extends({
      model: model
    }, props, {
      isPromoProduct: true,
      props: props
    })));
  }));
};

export default CardList;